import type { RouteRecordRaw } from "vue-router"

const financeRoutes: Array<RouteRecordRaw> = [
  {
    path: "/finance",
    name: "finance",
    children: [
      {
        path: "invoices",
        name: "invoices",
        component: () => import("@/views/invoice/InvoiceList.vue"),
        meta: {
          pageTitle: "Invoices",
          breadcrumbs: ["Finance", "Invoices"],
        },
      },
      {
        path: "invoice/:tag",
        name: "invoice",
        component: () => import("@/views/invoice/InvoiceDetails.vue"),
        meta: {
          pageTitle: "Invoices",
          breadcrumbs: ["Finance", "Invoices"],
        },
      },
      {
        path: "notifications",
        name: "notifications",
        component: () => import("@/views/finance/Notifications.vue"),
        meta: {
          pageTitle: "Notifications",
          breadcrumbs: ["Finance", "Notifications"],
        },
      },
    ],
  },
]

export default financeRoutes
